var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContext, useEffect } from 'react';
import { PrivateContext } from './IdentityProvider';
function redirect(destination, options = { timeout: 10000 }) {
    return __awaiter(this, void 0, void 0, function* () {
        const { timeout } = options;
        const unloadPromise = new Promise((resolve, reject) => {
            window.addEventListener('unload', event => {
                console.debug(`Browser unloading document before redirect to ${destination}, resolving promise`);
                resolve();
            });
            setTimeout(reject, timeout, `Unload event timeout after ${timeout}ms on redirect to ${destination}`);
            console.debug(`redirecting to ${destination}`);
            window.location.href = destination;
        });
        yield unloadPromise;
    });
}
export default function Redirector() {
    const { privateState, privateDispatch } = useContext(PrivateContext);
    const { redirectTarget } = privateState;
    useEffect(() => {
        if (!privateDispatch)
            return;
        if (!redirectTarget)
            return;
        privateDispatch({ type: 'BEGIN_REDIRECT', redirectTarget });
        redirect(redirectTarget).catch(error => {
            privateDispatch({ type: 'FATAL_ERROR', reason: `Attempt to redirect timed out.`, error });
            privateDispatch({ type: 'CANCEL_REDIRECT' });
        });
    }, [redirectTarget]);
    return null;
}
